import cn from 'classnames';
import ItemRing from './ItemRing';
import styles from './progressRing.module.scss';
import { actionColor, secondaryColor } from './constants';

export interface IProps {
  /**
   * Radius of the progress circle.
   */
  radius: number,
  /**
   * Thickness of the progress circle's stroke.
   */
  stroke: number,
  /**
   * Progress value to display (percentage or string representation).
   */
  progress: number | string,
  /**
   * Optional CSS class for the wrapper element.
   */
  wrapperClass?: string,
}

const ProgressRing = ({ radius, stroke, progress, wrapperClass }: IProps) => {
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const dividedCircumference = parseFloat(`${ progress }`) / 100;
  const strokeDashoffset = circumference - dividedCircumference * circumference;

  return (
    <div className={ cn(styles.progressRingWrp, wrapperClass) }>
      <span className={ styles.firstRing }>
        <ItemRing
          strokeColor={ actionColor }
          strokeDashoffset={ strokeDashoffset }
          normalizedRadius={ normalizedRadius }
          radius={ radius }
          stroke={ stroke }
          circumference={ circumference }
        />
      </span>
      <span className={ styles.secondRing }>
        <ItemRing
          strokeColor={ secondaryColor }
          strokeDashoffset={ 0 }
          normalizedRadius={ normalizedRadius }
          radius={ radius }
          stroke={ stroke }
          circumference={ circumference }
        />
      </span>
    </div>
  );
};

export default ProgressRing;
